"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IssueViews = void 0;
const ChartType_1 = __importDefault(require("@opsbase/lib-chart/ChartType"));
const ChartVariant_1 = __importDefault(require("@opsbase/lib-chart/ChartVariant"));
const QueryFieldKey_1 = __importDefault(require("@opsbase/lib-data-queryfield/QueryFieldKey"));
const ViewFieldKey_1 = __importDefault(require("@opsbase/lib-data-viewfield/ViewFieldKey"));
const ViewFieldRegistry_1 = __importDefault(require("@opsbase/lib-data-viewfield/ViewFieldRegistry"));
const DataType_1 = __importDefault(require("@opsbase/lib-datatype/DataType"));
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const App_1 = __importDefault(require("@opsbase/lib-system/App"));
const DateRanges_1 = __importDefault(require("@opsbase/lib-time/DateRanges"));
const View_1 = __importDefault(require("../View"));
const LAST7DAYS = DateRanges_1.default.LAST7DAYS;
const YESTERDAY = DateRanges_1.default.YESTERDAY;
exports.IssueViews = [
    new View_1.default({
        apps: [App_1.default.OPSBASE],
        id: 'openissues',
        title: () => lib_i18n_1.default.t('last-7-days'),
        type: DataType_1.default.ISSUE,
        filters: [
            {
                title: LAST7DAYS.title,
                queryFieldKey: QueryFieldKey_1.default.ISSUE_OCCURRENCEDATE,
                interval: LAST7DAYS.interval,
                from: LAST7DAYS.from(),
                to: LAST7DAYS.to(LAST7DAYS.from()),
            },
        ],
        sortBy: ViewFieldKey_1.default.ISSUE_OCCURRENCE,
        sortByDesc: true,
        groupBys: [QueryFieldKey_1.default.ISSUE_STATUS],
        fields: [
            ViewFieldRegistry_1.default[ViewFieldKey_1.default.TITLE],
            ViewFieldRegistry_1.default[ViewFieldKey_1.default.PLACE],
            ViewFieldRegistry_1.default[ViewFieldKey_1.default.ISSUE_FLAG],
            ViewFieldRegistry_1.default[ViewFieldKey_1.default.ISSUE_ASSIGNEDTO],
            ViewFieldRegistry_1.default[ViewFieldKey_1.default.ISSUE_OCCURRENCE],
            ViewFieldRegistry_1.default[ViewFieldKey_1.default.ISSUE_TYPE],
        ],
        chartBox: {
            visible: true,
            charts: [
                {
                    key: QueryFieldKey_1.default.ISSUE_OCCURRENCEDATE,
                    chartType: ChartType_1.default.BAR3DSTACK,
                    chartVariant: ChartVariant_1.default.COUNT_GROUP_TIME,
                    config: {
                        timeDimension: QueryFieldKey_1.default.ISSUE_OCCURRENCEDATE,
                        otherDimension: QueryFieldKey_1.default.ISSUE_STATUS,
                    },
                },
                {
                    key: QueryFieldKey_1.default.ISSUE_STATUS,
                    chartType: ChartType_1.default.PIE2D,
                    chartVariant: ChartVariant_1.default.COUNT_GROUP,
                    config: {
                        dimension: QueryFieldKey_1.default.ISSUE_STATUS,
                    },
                },
            ],
        },
    }),
    new View_1.default({
        apps: [App_1.default.OPSBASE],
        id: 'issuesyesterday',
        title: () => lib_i18n_1.default.t('yesterday'),
        type: DataType_1.default.ISSUE,
        filters: [
            {
                title: YESTERDAY.title,
                queryFieldKey: QueryFieldKey_1.default.ISSUE_OCCURRENCEDATE,
                interval: YESTERDAY.interval,
                from: YESTERDAY.from(),
                to: YESTERDAY.to(YESTERDAY.from()),
            },
        ],
        sortBy: ViewFieldKey_1.default.ISSUE_OCCURRENCE,
        sortByDesc: true,
        chartBox: {
            visible: true,
            charts: [
                {
                    key: QueryFieldKey_1.default.ISSUE_STATUS,
                    chartType: ChartType_1.default.PIE2D,
                    chartVariant: ChartVariant_1.default.COUNT_GROUP,
                    config: {
                        dimension: QueryFieldKey_1.default.ISSUE_STATUS,
                    },
                },
            ],
        },
        groupBys: [QueryFieldKey_1.default.ISSUE_STATUS],
        fields: [
            ViewFieldRegistry_1.default[ViewFieldKey_1.default.TITLE],
            ViewFieldRegistry_1.default[ViewFieldKey_1.default.PLACE],
            ViewFieldRegistry_1.default[ViewFieldKey_1.default.ISSUE_FLAG],
            ViewFieldRegistry_1.default[ViewFieldKey_1.default.ISSUE_ASSIGNEDTO],
            ViewFieldRegistry_1.default[ViewFieldKey_1.default.ISSUE_OCCURRENCE],
            ViewFieldRegistry_1.default[ViewFieldKey_1.default.ISSUE_TYPE],
        ],
    }),
    new View_1.default({
        apps: [App_1.default.OPSBASE],
        id: 'allissues',
        title: () => lib_i18n_1.default.t('all'),
        type: DataType_1.default.ISSUE,
        filters: [],
        sortBy: ViewFieldKey_1.default.ISSUE_OCCURRENCE,
        sortByDesc: true,
        groupBys: [],
        fields: [
            ViewFieldRegistry_1.default[ViewFieldKey_1.default.TITLE],
            ViewFieldRegistry_1.default[ViewFieldKey_1.default.PLACE],
            ViewFieldRegistry_1.default[ViewFieldKey_1.default.ISSUE_STATUS],
            ViewFieldRegistry_1.default[ViewFieldKey_1.default.ISSUE_FLAG],
            ViewFieldRegistry_1.default[ViewFieldKey_1.default.ISSUE_ASSIGNEDTO],
            ViewFieldRegistry_1.default[ViewFieldKey_1.default.ISSUE_OCCURRENCE],
            ViewFieldRegistry_1.default[ViewFieldKey_1.default.ISSUE_TYPE],
        ],
    }),
];
exports.default = exports.IssueViews;
